import { render, staticRenderFns } from "./BacklogBackup.vue?vue&type=template&id=dba8ec34&"
import script from "./BacklogBackup.vue?vue&type=script&lang=js&"
export * from "./BacklogBackup.vue?vue&type=script&lang=js&"
import style0 from "./BacklogBackup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports